import ChartGroupingLevelSelectorFillingStrategy from './ChartGroupingLevelSelectorFillingStrategy'

function UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new ChartGroupingLevelSelectorFillingStrategy();

UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    this.addUsersItem( listSelector );
    this.addUserGroupsItemIfNeeded( listSelector );
    this.addTimeZoneGroupsItemIfNeeded( listSelector );

    listSelector.addSeparator();

    this.addDaysItem( listSelector );
    this.addWeeksItem( listSelector );
    this.addMonthsItem( listSelector );
};

export default UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.js